export const elementType = {
	PRIMARY: 'primary',
	WARNING: 'warning',
	DANGER: 'danger',
	SUCCESS: 'success',
};
